<template>
  <div class="result-screen">
    <div class="result-hero">
      <div class="result-emoji">{{ resultEmoji }}</div>
      <div class="result-title">{{ resultTitle }}</div>
      <div class="result-sub">{{ resultSub }}</div>
    </div>

    <!-- Animated score ring -->
    <div class="score-ring-wrap">
      <svg viewBox="0 0 150 150" width="150" height="150">
        <defs>
          <linearGradient id="ringGrad" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style="stop-color:#7c5cfc"/>
            <stop offset="100%" style="stop-color:#fc5c7d"/>
          </linearGradient>
        </defs>
        <circle class="ring-bg" cx="75" cy="75" r="60"/>
        <circle
          class="ring-fg"
          cx="75" cy="75" r="60"
          :style="{ strokeDashoffset: ringOffset }"
        />
      </svg>
      <div class="score-inner">
        <div class="score-num">{{ result.correct }}/{{ result.total }}</div>
        <div class="score-pct">{{ pct }}%</div>
      </div>
    </div>

    <!-- Quick stats -->
    <div class="result-stats">
      <div class="rs-card">
        <div class="rs-val" style="color:var(--accent2)">{{ result.correct }}</div>
        <div class="rs-lbl">To'g'ri</div>
      </div>
      <div class="rs-card">
        <div class="rs-val" style="color:var(--accent)">{{ result.wrong }}</div>
        <div class="rs-lbl">Noto'g'ri</div>
      </div>
      <div class="rs-card">
        <div class="rs-val" style="color:var(--gold)">{{ result.points }}</div>
        <div class="rs-lbl">Ball</div>
      </div>
    </div>

    <div class="result-actions">
      <button class="btn-primary" @click="$emit('retry')">🔄 Qayta o'ynash</button>
      <button class="btn-secondary" @click="$emit('home')">🏠 Bosh sahifa</button>
    </div>
  </div>
</template>

<script>
const CIRCUMFERENCE = 2 * Math.PI * 60  // ≈ 376.99

export default {
  name: 'ResultView',
  emits: ['retry', 'home'],

  props: {
    result: { type: Object, required: true },
  },

  data() {
    return { ringOffset: CIRCUMFERENCE }
  },

  computed: {
    pct() {
      return Math.round(this.result.correct / this.result.total * 100)
    },
    resultEmoji() {
      if (this.pct === 100) return '🏆'
      if (this.pct >= 80)  return '🎉'
      if (this.pct >= 60)  return '👍'
      if (this.pct >= 40)  return '💪'
      return '📚'
    },
    resultTitle() {
      if (this.pct === 100) return 'Mukammal!'
      if (this.pct >= 80)  return 'Ajoyib!'
      if (this.pct >= 60)  return 'Yaxshi!'
      if (this.pct >= 40)  return 'Harakat qiling!'
      return "Ko'proq o'qing!"
    },
    resultSub() {
      if (this.pct === 100) return "Barcha savollarga to'g'ri javob berdingiz!"
      if (this.pct >= 80)  return "Siz juda yaxshi natija ko'rsatdingiz!"
      if (this.pct >= 60)  return "Davom eting, natijangiz yaxshi!"
      if (this.pct >= 40)  return "Bilimingizni oshirishingiz mumkin"
      return "Bilim — kuch, davom eting!"
    },
  },

  mounted() {
    // Animate ring after mount
    this.$nextTick(() => {
      setTimeout(() => {
        this.ringOffset = CIRCUMFERENCE - (this.pct / 100) * CIRCUMFERENCE
      }, 120)
    })
  },
}
</script>
